import React, { useContext } from 'react';
import ThemeContext from '../../../../providers/ThemeProvider';

const BookingCalendarNavTop = () => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <div className="booking-calendar-nav-top" />
      <style jsx>{`
        .booking-calendar-nav-top {
          background-color: ${theme.colors.primary};
          color: ${theme.colors.textonprimary};
          border-radius: 8px 8px 0 0;
          height: 8px;
        }
      `}</style>
    </>
  );
};

export default BookingCalendarNavTop;
